// Mock data for labor metrics dashboard components
export const mockLaborMetrics = [
  {
    shiftId: 'shift-1',
    date: '2024-03-20',
    totalFTE: 12,
    plannedFTE: 10,
    actualHours: 8.5,
    plannedHours: 8,
    utilization: 85,
    productivity: 92,
    breakTime: 1,
    activeTime: 7.5,
  },
];

export const mockProductivityMetrics = {
  unitsPerHour: 120,
  linesPerHour: 45,
  ordersPerHour: 15,
  costPerUnit: 2.5,
  efficiency: 88,
  targetProductivity: 100,
};

export const mockFatigueMetrics = [
  {
    userId: 'user-1',
    timestamp: '2024-03-20T08:00:00Z',
    avgDistance: 650,
    avgWeight: 10,
    avgVolume: 0.3,
    temperature: 21,
    productivityTrend: 95,
    restNeeded: false,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T09:00:00Z',
    avgDistance: 750,
    avgWeight: 11,
    avgVolume: 0.35,
    temperature: 21.5,
    productivityTrend: 90,
    restNeeded: false,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T10:00:00Z',
    avgDistance: 850,
    avgWeight: 12,
    avgVolume: 0.4,
    temperature: 22,
    productivityTrend: 85,
    restNeeded: false,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T11:00:00Z',
    avgDistance: 950,
    avgWeight: 13,
    avgVolume: 0.5,
    temperature: 23,
    productivityTrend: 80,
    restNeeded: false,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T12:00:00Z',
    avgDistance: 1200,
    avgWeight: 15,
    avgVolume: 0.6,
    temperature: 24,
    productivityTrend: 78,
    restNeeded: true,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T13:00:00Z',
    avgDistance: 900,
    avgWeight: 12,
    avgVolume: 0.45,
    temperature: 22.5,
    productivityTrend: 82,
    restNeeded: false,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T14:00:00Z',
    avgDistance: 800,
    avgWeight: 11,
    avgVolume: 0.4,
    temperature: 22,
    productivityTrend: 86,
    restNeeded: false,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T15:00:00Z',
    avgDistance: 750,
    avgWeight: 10,
    avgVolume: 0.35,
    temperature: 21.5,
    productivityTrend: 88,
    restNeeded: false,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T16:00:00Z',
    avgDistance: 1100,
    avgWeight: 14,
    avgVolume: 0.55,
    temperature: 23.5,
    productivityTrend: 75,
    restNeeded: true,
  },
  {
    userId: 'user-1',
    timestamp: '2024-03-20T17:00:00Z',
    avgDistance: 700,
    avgWeight: 9,
    avgVolume: 0.3,
    temperature: 21,
    productivityTrend: 83,
    restNeeded: false,
  },
];
